var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 7.25,
    stroke: "#0C5EFF",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39258 4.08594C8.56445 4.08594 8.71094 4.14844 8.83203 4.27344C8.95312 4.39453 9.01367 4.54102 9.01367 4.71289C9.01367 4.89258 8.95312 5.04297 8.83203 5.16406C8.71484 5.28516 8.56836 5.3457 8.39258 5.3457C8.23242 5.3457 8.08984 5.2832 7.96484 5.1582C7.84375 5.0293 7.7832 4.88086 7.7832 4.71289C7.7832 4.54492 7.84375 4.39844 7.96484 4.27344C8.08984 4.14844 8.23242 4.08594 8.39258 4.08594ZM8.83789 12.5H7.92383V7.18555H6.125V6.39453H8.83789V12.5Z",
    fill: "#0C5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamation-icon.cacf12918a34853e4d4014710f87bb68.svg";
export { ForwardRef as ReactComponent };